import {
  IAggregatedField,
  IAggregationQuery,
  ICollectionSchemaResponse,
} from "../types";

export const getAggregatedFields = (
  query: IAggregationQuery,
  schema: ICollectionSchemaResponse
): IAggregatedField[] => {
  const fields: IAggregatedField[] = [];
  if (!query) {
    return fields;
  }
  query.groupby.forEach((element) => {
    fields.push({
      name: element.name,
      field: element.field,
      type: schema[element.field],
      agg: element.agg,
    });
  });

  fields.push({
    field: "frequency",
    name: "frequency",
    type: "numeric",
    agg: "sum",
  });

  query.metrics.forEach((element) => {
    fields.push({
      name: element.name,
      field: element.field,
      type: schema[element.field],
      agg: element.agg,
    });
  });

  return fields;
};

export const getGroupingFields = (schema: ICollectionSchemaResponse) => {
  return Object.keys(schema).filter((x) => schema[x] === "text");
};

export const getMetricsFields = (schema: ICollectionSchemaResponse) => {
  return Object.keys(schema).filter((x) => schema[x] === "numeric");
};

export const applyCollectionFilters = (
  data: any[],
  sortBy: IAggregatedField
) => {
  return data.sort((a, b) =>
    a[sortBy.field] > b[sortBy.field]
      ? 1
      : b[sortBy.field] > a[sortBy.field]
      ? -1
      : 0
  );
};

export const getClusteringFields = (fields: IAggregatedField[]) => {
  return [...new Set(fields.map((x) => x.field))];
};

export const getVectorFields = (schema: ICollectionSchemaResponse) => {
  return Object.keys(schema).filter((x) => schema[x] === "vector");
};

export const getAllFields = (schema: ICollectionSchemaResponse) =>
  Object.keys(schema)
    .filter((x) => !(schema[x] === "dict" || schema[x] === "vector"))
    .map((x) => ({ field: x, type: schema[x] }));
